// extracted by mini-css-extract-plugin
export default {"title":"hba-z","warning":"iba-z","sizeOptionsLegendText":"jba-z"};